import React from "react";
import { Pressable, Text } from "react-native";
import tw from "twrnc";

const AppSubtitle = ({ style, text, onPress }) => {
  const subtitleStyles = tw`m-0.5 pt-2 pb-2 text-left text-[#2E3F52]`;

  return onPress ? (
    <Pressable onPress={onPress}>
      <Text style={[subtitleStyles, style]}>{text}</Text>
    </Pressable>
  ) : (
    <Text style={[subtitleStyles, style]}>{text}</Text>
  );
};

export default AppSubtitle;
